import { render, staticRenderFns } from "./attributeInformation.vue?vue&type=template&id=514d602d&scoped=true&"
import script from "./attributeInformation.vue?vue&type=script&lang=js&"
export * from "./attributeInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514d602d",
  null
  
)

export default component.exports